module.exports = require("@material-ui/core/LinearProgress");